import { useFetchClientQuery } from 'api';
import { ClientContext, useAuth } from 'core';
import { ReactNode } from 'react';
import { LoadingSkeleton } from '.';

export interface ClientProviderProps {
  children: ReactNode;
}

export const ClientProvider = (props: ClientProviderProps) => {
  const { children } = props;

  const auth = useAuth();
  const { data: client } = useFetchClientQuery(
    auth?.user.clientId ?? "0",
    {
      skip: !auth?.user.clientId,
    }
  );

  return (
    <LoadingSkeleton isLoaded={!!client}>
      <ClientContext.Provider value={client!}>
        {children}
      </ClientContext.Provider>
    </LoadingSkeleton>
  );
};
